import { isValidPhoneNumber } from 'react-phone-number-input';

import { EmailValidationRegex, URLValidationRegex } from 'src/constants';
import { PropertyFieldMappings } from 'src/features/crm/properties/EditableInput';
import { CustomFieldType } from 'src/store/clients/types';

/**
 * This function checks if input value is
 * valid or not based on the field type.
 * @param fieldType: custom field type (text, url, email, address)
 * @param val: current input type
 */
export const getFieldValidationByType = (
  fieldType: CustomFieldType,
  val: string,
) => {
  // when input is empty don't show validation text
  if (!val) return '';

  if (fieldType === 'email') {
    const emailRegex = new RegExp(EmailValidationRegex);
    if (!val.toString().match(emailRegex)) {
      return PropertyFieldMappings?.email?.validation?.invalidText || '';
    }
  }

  if (fieldType === 'url') {
    const urlRegex = new RegExp(URLValidationRegex);
    if (!val.toString().match(urlRegex)) {
      return PropertyFieldMappings?.url?.validation?.invalidText || '';
    }
  }

  if (fieldType === 'phoneNumber') {
    if (!isValidPhoneNumber(val)) {
      return PropertyFieldMappings?.phoneNumber?.validation?.invalidText || '';
    }
  }
  if (fieldType === 'number') {
    if (isNaN(Number(val))) {
      return PropertyFieldMappings.number?.validation?.invalidText || '';
    }
  }

  return '';
};
